// https://stackoverflow.com/a/14555361
const storage = name => ({
  getItem: (key, defVal) => {
    let value = defVal;

    try {
      value = JSON.parse(window[`${name}Storage`].getItem(key));  
    } catch (e) {
      console.error(e);
    }
  
    return value;
  },
  setItem: (key, value) => {
    try {
      window[`${name}Storage`].setItem(key, JSON.stringify(value));  
    } catch (e) {
      console.error(e);
    }
  }
});

export const safeLocalStorage = storage('local');
export const safeSessionStorage = storage('session');